import "./Consultation.module.css";
import GlobalLogisticsHeader from "@/reusable_sections/Header";
import LetsBuildTheFuture from "./sections/LetsBuildTheFuture";
import OurCampus from "./sections/OurCampus";
import ClinicFooter from "@/reusable_sections/Footer";
export default function ConsultationPage() {
  return <div>
      <GlobalLogisticsHeader />
      <LetsBuildTheFuture />
      <OurCampus />
      <ClinicFooter />
    </div>;
}